import { render, staticRenderFns } from "./TodoHeader.vue?vue&type=template&id=fb449fc2&scoped=true&"
import script from "./TodoHeader.vue?vue&type=script&lang=js&"
export * from "./TodoHeader.vue?vue&type=script&lang=js&"
import style0 from "./TodoHeader.vue?vue&type=style&index=0&id=fb449fc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb449fc2",
  null
  
)

export default component.exports